import { observable } from "mobx";
import { ModelBase } from "../../Core/Models/ModelBase";

export class IndustryContactModel extends ModelBase<IndustryContactModel, IndustryContactDTO> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public name: string = "";

    @observable
    public phoneNumber: string = "";

    @observable
    public email: string = "";

    @observable
    public faxNumber: string = "";

    @observable
    public addressLine1: string = "";

    @observable
    public addressLine2: string = "";

    @observable
    public city: string = "";

    @observable
    public postcode: string = "";

    @observable
    public industryContactTypeId: string = "";

    @observable
    public sellers: boolean = false;

    @observable
    public buyers: boolean = false;

    @observable
    public makeDefault: boolean = false;

    @observable
    public dateAdded: string = "";

    @observable
    public isDeleted: boolean = false;

    @observable
    public isSoleTrader: boolean = false;

    @observable
    public receiveNotifications: boolean = false;

    @observable
    public typeId?: string = "";
    //#endregion roperties

    public fromDto = (industryContactDto: IndustryContactDTO) => {
        this.id = industryContactDto.id;
        this.dateAdded = industryContactDto.dateAdded;
        this.industryContactTypeId = industryContactDto.industryContactTypeId;
        this.isDeleted = industryContactDto.isDeleted;
        this.name = industryContactDto.name;
        this.addressLine1 = industryContactDto.addressLine1;
        this.addressLine2 = industryContactDto.addressLine2;
        this.city = industryContactDto.city;
        this.email = industryContactDto.email;
        this.faxNumber = industryContactDto.faxNumber;
        this.phoneNumber = industryContactDto.phoneNumber;
        this.postcode = industryContactDto.postcode;
        this.sellers = industryContactDto.sellers;
        this.buyers = industryContactDto.buyers;
        this.isSoleTrader = industryContactDto.isSoleTrader;
        this.receiveNotifications = industryContactDto.receiveNotifications;
        this.makeDefault = industryContactDto.makeDefault;
        this.typeId = industryContactDto.typeId;
    };

    public toDto = (): IndustryContactDTO => {
        return {
            id: this.id,
            dateAdded: this.dateAdded,
            industryContactTypeId: this.industryContactTypeId,
            isDeleted: this.isDeleted,
            addressLine1: this.addressLine1,
            addressLine2: this.addressLine2,
            city: this.city,
            email: this.email,
            faxNumber: this.faxNumber,
            name: this.name,
            phoneNumber: this.phoneNumber,
            postcode: this.postcode,
            sellers: this.sellers,
            buyers: this.buyers,
            makeDefault: this.makeDefault,
            isSoleTrader: this.isSoleTrader,
            receiveNotifications: this.receiveNotifications,
            typeId: this.typeId,
        };
    };
}

export interface IndustryContactDTO {
    id: string | undefined;
    industryContactTypeId: string;
    dateAdded: string;
    isDeleted: boolean;
    name: string;
    phoneNumber: string;
    faxNumber: string;
    email: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    postcode: string;
    sellers: boolean;
    buyers: boolean;
    makeDefault: boolean;
    isSoleTrader: boolean;
    receiveNotifications: boolean;
    typeId?: string;
}
